import styled from 'styled-components'

import Heading from '../Typography/Heading'
import Link from '../Link/styled'

const FooterHeading = styled(Heading)`
  font-weight: 600;
  font-size: 1em;
  width: 100%;

  ${Link} {
    font-weight: normal;
  }

  * + & {
    margin-top: ${props => props.theme.gutter}px;
  }
`

export default FooterHeading
